import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DatosUsuariosService } from '../../../services/datos-usuarios.service';
import { DatosEmpleadosService } from 'src/app/pages/empleados/services/mantenimiento/datos-empleados.service';

@Component({
  selector: 'app-usuario-activo-conf',
  templateUrl: './usuario-activo-conf.component.html',
  styleUrls: ['./usuario-activo-conf.component.css']
})
export class UsuarioActivoConfComponent implements OnInit {

  @Output() guardarcambios: EventEmitter<string> = new EventEmitter<string>();
  hidePassword: boolean = true;

  constructor(public datosUsuariosService: DatosUsuariosService,
              private datosEmpleadosService: DatosEmpleadosService
  ) { }


  ngOnInit(): void {
    this.getConfiguracionAplicacion();

  }

  get nombre(){ return this.datosUsuariosService.usuarioActivoForm.controls['nombre']}
  get apellido1(){ return this.datosUsuariosService.usuarioActivoForm.controls['apellido1']}
  get email(){ return this.datosUsuariosService.usuarioActivoForm.controls['email']}
  get usuarioA3Trans(){ return this.datosUsuariosService.usuarioActivoForm.controls['usuarioA3Trans']}
  get passwordA3(){ return this.datosUsuariosService.usuarioActivoForm.controls['passwordA3']}

  guardar(){
    this.guardarcambios.emit('guardar');
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  getConfiguracionAplicacion(){
    this.datosEmpleadosService.getConfiguracionAplicacion().subscribe(
      next => {
        if(next.TipoIntegracion == 'A3') {
          this.datosUsuariosService.integracionA3 = true;
        }else {
          this.datosUsuariosService.integracionA3 = false;
        }
        this.datosUsuariosService.inicializarUsuarioActivoForm();
      },
      error => {
        console.error();
      }
    )
  }

  cargandoForm(): boolean {
    if(this.datosUsuariosService.usuarioActivoForm.controls && Object.keys(this.datosUsuariosService.usuarioActivoForm.controls).length > 0) return true;
    return false;
  }
}
